import { render, staticRenderFns } from "./JLinkInput.vue?vue&type=template&id=ed96cd4e"
import script from "./JLinkInput.vue?vue&type=script&lang=js"
export * from "./JLinkInput.vue?vue&type=script&lang=js"
import style0 from "./JLinkInput.vue?vue&type=style&index=0&id=ed96cd4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports